import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AutenticaCli } from '@laranda/lib-ucontrol';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  formLogin: FormGroup;
  verPass: string;

  constructor(
    public autenticaCli: AutenticaCli,
    private fb: FormBuilder
  ) {
    this.formLogin = this.fb.group({
      correo: ['', [Validators.required, Validators.pattern('[a-z|A-Z0-9._%+-]+@[a-z|A-Z0-9.-]+\.[a-z|A-Z]{2,3}$')]],
      password: ['', [Validators.required, Validators.minLength(4)]]
    });
  }

  ngOnInit() {
    this.autenticaCli.ParamIn.email = '';
    this.autenticaCli.ParamIn.password = '';
    this.verPass = 'password';
  }

  get correoNoValido() {
    return (this.formLogin.get('correo').invalid && this.formLogin.get('correo').touched);
  }

  get passwordNoValido() {
    return (this.formLogin.get('password').invalid && this.formLogin.get('password').touched);
  }

  onLogin( ) {

    Object.values( this.formLogin.controls ).forEach( control => {
      if ( control.invalid ) {
        control.markAllAsTouched();
      }
    });

    if (this.formLogin.valid) {
      this.autenticaCli.ParamIn.email = this.formLogin.value.correo;
      this.autenticaCli.ParamIn.password = this.formLogin.value.password;

      debugger;
      this.autenticaCli.logIn();
    }
  }

  claveVisible() {
    this.verPass = 'text';
  }
  claveOculta() {
    this.verPass = 'password';
  }
}
